<!-- src/components/NotFound.vue -->
<template>
  <div class="not-found">
    <h1>404 Not Found</h1>
    <p>Sorry, the page you are looking for does not exist.</p>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 50px;
}
</style>


// WEBPACK FOOTER //
// src/view/base/register.vue